import script from "./SidebarPC.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarPC.vue?vue&type=script&setup=true&lang=js"

import "./SidebarPC.vue?vue&type=style&index=0&id=351eea50&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-351eea50"]])

export default __exports__